var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"player-show"}},[_c('div',{staticClass:"player"},[_c('div',{staticClass:"player-timeline"},[_c('vue-plyr',{ref:"plyr",attrs:{"options":{
          autoplay: true,
          loadSprite: false,
          controls: ['play-large', 'play', 'progress', 'current-time'],
          blankAudio: require('@/assets/blank.mp4')
        }}},[_c('audio',{attrs:{"src":_vm.targetAudioFile}})])],1),_c('div',{staticClass:"player-status-label"},[_vm._v(" "+_vm._s(_vm.prettyIsPlaying)+" STOP "+_vm._s(_vm.currentStopFormatted)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }